export const OutboundIPs = [
  { address: "34.133.249.87", internalDescription: "sandbox-egress-1 static IP for NAT", phase: "active" },
  { address: "34.30.198.177", internalDescription: "sandbox-egress-2 static IP for NAT", phase: "active" },
  { address: "104.197.69.10", internalDescription: "sandbox-egress-3 static IP for NAT", phase: "active" },
  {
    address: "34.171.201.14",
    internalDescription: "sandbox-egress-4 static IP for NAT",
    phase: "advance warning, will go into service in 2025-10-23",
  },
];
